import { BRAND } from '@/config/brand';
import { cn } from '@/utils/cn';

/** Product mark: a document corner with a bolt cut through it. */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" className={cn('size-8', className)}>
      <defs>
        <linearGradient id="ql-logo" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="var(--accent)" />
          <stop offset="100%" stopColor="var(--accent-hover)" />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="30" height="30" rx="9" fill="url(#ql-logo)" />
      <path
        d="M17.6 7 10 17.6h4.6L13.4 25 22 14.2h-5.2L17.6 7Z"
        fill="#fff"
        fillOpacity="0.96"
      />
    </svg>
  );
}

export function Logo({ className }: { className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <LogoMark />
      <span className="text-[15px] font-semibold tracking-[-0.015em] text-ink">{BRAND.name}</span>
    </span>
  );
}
